import { Currency } from "../models";

export const Currencies: Currency[] = [
    {
        name:'euro',
        code:'EUR',
        symbol:'€'
    },
    {
        name:'pound',
        code:'GBP',
        symbol:'£'
    },
    {
        name:'us_dollar',
        code:'USD',
        symbol:'$'
    }
]